define('ordersDetailOrderClientCommentsView',[
  'module',
  'marionette',
  'backbone',
  'underscore',
  'entities/orders',
  'ordersDetailOrderClientCommentView',
  'template!ordersDetailOrderClientCommentsView'
], function (
  Module,
  Marionette,
  Backbone,
  _,    
  Orders,
  CommentView,
  Tpl
) {
  'use strict';   

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'orders-detail-order-client-comments-view',   
    childView: CommentView,
    childViewContainer: '.comments-ctn',

    ui: {
      noComments: '.no-comments'
    },

    modelEvents: {      
      'change:comments': 'fetch'     
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
    },

    onShow: function () {
      this.fetch();
    },

    filter: function (model) {
      if(model.get('type') && model.get('type') === 'customer')
        return true;
      else
        return false;
    },

    onRender: function () {
      this.renderContent();
    },

    renderContent: function () {
      var models = _.filter(this.collection.models, function(model) {
        return (model.get('type') && model.get('type') === 'customer');
      });

      if(models.length === 0)
        this.ui.noComments.show();
      else
        this.ui.noComments.hide();
    },

    fetch: function () {
      var collection = new Backbone.Collection(this.model.get('comments'));
      var models = collection.models.sort(function (a, b) {
          return a.get('msgDate') < b.get('msgDate') ? 1 : -1;
      });

      this.collection.reset(models);
      this.renderContent();
    }    
  });
});
